import { render, staticRenderFns } from "./rich-text.component.vue?vue&type=template&id=717ed6cf"
import script from "./rich-text.component.vue?vue&type=script&lang=js"
export * from "./rich-text.component.vue?vue&type=script&lang=js"
import style0 from "./rich-text.component.vue?vue&type=style&index=0&id=717ed6cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports